function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "complete_skill_rating",
  "data-name": "complete skill rating",
  transform: "translate(-893.452 -1129)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_3228",
  "data-name": "Ellipse 3228",
  transform: "translate(928 1138)",
  fill: "none",
  stroke: "#828b96",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 36,
  r: 36,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 36,
  r: 35,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_19945",
  "data-name": "Group 19945",
  transform: "translate(-206.584 335.844)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_7",
  "data-name": "Group 7",
  transform: "translate(189.559 526.519)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_16942",
  "data-name": "Group 16942",
  transform: "translate(996.106 266.638)",
  opacity: 0.294
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518",
  "data-name": "Rectangle 7518",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(4.14)",
  fill: "#484751"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519",
  "data-name": "Rectangle 7519",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(9.936 4.14) rotate(90)",
  fill: "#484751"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_16960",
  "data-name": "Group 16960",
  transform: "translate(910.478 307.437)",
  opacity: 0.19
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518-2",
  "data-name": "Rectangle 7518",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(4.14)",
  fill: "#484751"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519-2",
  "data-name": "Rectangle 7519",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(9.936 4.14) rotate(90)",
  fill: "#484751"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2778",
  "data-name": "Ellipse 2778",
  transform: "translate(1011.984 340.313)",
  fill: "#fff",
  stroke: "#484751",
  strokeWidth: 2,
  opacity: 0.16
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 3.726,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 2.726,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2779",
  "data-name": "Ellipse 2779",
  transform: "translate(1036.568 276.574)",
  fill: "#fff",
  stroke: "#484751",
  strokeWidth: 2,
  opacity: 0.17
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 3.726,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 2.726,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2780",
  "data-name": "Ellipse 2780",
  transform: "translate(923.026 328.184)",
  fill: "#fff",
  stroke: "#484751",
  strokeWidth: 2,
  opacity: 0.294
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 3.726,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 2.726,
  fill: "none"
})), /*#__PURE__*/React.createElement("line", {
  id: "Line_2216",
  "data-name": "Line 2216",
  x2: 31.609,
  transform: "translate(1019.775 297.921)",
  fill: "none",
  stroke: "#c9c9cc",
  strokeWidth: 1,
  strokeDasharray: 6
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2217",
  "data-name": "Line 2217",
  x2: 33.988,
  transform: "translate(1019.435 307.437)",
  fill: "none",
  stroke: "#c9c9cc",
  strokeWidth: 1,
  strokeDasharray: 6
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_8",
  "data-name": "Group 8",
  transform: "translate(173.559 51.944)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18022",
  "data-name": "Group 18022",
  transform: "translate(976.529 763.488)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union_57",
  "data-name": "Union 57",
  d: "M24.331,41.278l-4.176-2.1-4.184,2.1a1.626,1.626,0,0,1-2.34-1.69l.718-4.61-3.3-3.311a1.617,1.617,0,0,1,.89-2.738l4.623-.748,2.143-4.147a1.626,1.626,0,0,1,2.886,0l2.142,4.147,4.626.748a1.618,1.618,0,0,1,.894,2.738l-3.3,3.311.719,4.61a1.625,1.625,0,0,1-1.606,1.865A1.665,1.665,0,0,1,24.331,41.278Zm.577-1.132a.346.346,0,0,0,.36-.03.354.354,0,0,0,.141-.334L24.6,34.536l3.754-3.766a.349.349,0,0,0-.2-.585L22.9,29.331l-2.438-4.718a.344.344,0,0,0-.614,0L17.4,29.331l-5.253.854a.348.348,0,0,0-.277.232.368.368,0,0,0,.082.353l3.752,3.766-.81,5.247a.349.349,0,0,0,.5.363l4.759-2.393Zm13.6-.1-2.9-1.485L32.7,40.048h0a.356.356,0,0,1-.5-.391l.556-3.115-2.334-2.209a.367.367,0,0,1,.2-.627l3.236-.46L35.3,30.4a.335.335,0,0,1,.61,0l1.448,2.85,3.239.46a.364.364,0,0,1,.182.627l-2.33,2.209L39,39.657a.356.356,0,0,1-.341.429A.331.331,0,0,1,38.508,40.048Zm-30.314,0L5.288,38.562l-2.9,1.485a.349.349,0,0,1-.491-.391l.549-3.115L.112,34.333A.368.368,0,0,1,.3,33.706l3.241-.46L4.982,30.4a.34.34,0,0,1,.615,0l1.443,2.85,3.242.46a.368.368,0,0,1,.188.627L8.138,36.542l.55,3.115a.356.356,0,0,1-.341.429A.324.324,0,0,1,8.195,40.048ZM31.328,26.689V20.7a2.032,2.032,0,0,0-1.173-1.877,23.373,23.373,0,0,0-9.7-2.126h-.095c-.209,0-.421.005-.653.01s-.443,0-.65,0h-.1a23.39,23.39,0,0,0-9.7,2.12A2.04,2.04,0,0,0,8.082,20.7v5.989a1.01,1.01,0,0,1-2.02,0V20.7A4.113,4.113,0,0,1,8.4,16.994a26.019,26.019,0,0,1,10.652-2.3c.212,0,.43,0,.656.01.225-.01.443-.01.656-.01a26.021,26.021,0,0,1,10.653,2.3,4.111,4.111,0,0,1,2.34,3.706v5.989a1.013,1.013,0,0,1-2.026,0ZM11.987,7.049A7.071,7.071,0,1,1,19.058,14.1,7.061,7.061,0,0,1,11.987,7.049Zm2.019.08A5.052,5.052,0,1,0,19.058,2.1,5.044,5.044,0,0,0,14.005,7.129Z",
  transform: "translate(0 0)",
  fill: "#f3994e"
})))));
function SvgCompleteSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142.946,
    height: 81.128,
    viewBox: "0 0 142.946 81.128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteSurvey);
export default __webpack_public_path__ + "static/media/complete-survey.eae6fdaa.svg";
export { ForwardRef as ReactComponent };